import axios from 'axios';
import Vue from 'vue';
import { gotoLogin } from '@/common/utils'
import { Message } from "tsa-ui";

// 取消正在进行中的请求
let cancel = {}
let allowCancelList = ['get+api/videoResult', 'get+api/videoTask']

function generateCancelFun(config) {
    let method = config.method
    let url = config.url.split('?')[0]
    return method + '+' + url
}
/**
 * 自定义Axios实例
 */

const AJAX = axios.create({
    baseURL: '/',
    timeout: 86400000,
    // timeout: 1,
    // withCredentials: env.credential
});
// 添加请求拦截器
AJAX.interceptors.request.use(function (config) {
    config.cancelToken = new axios.CancelToken(function(c) {
        // config.headers['Authorization'] = 'Bearer 7400fe5688064a40a88243460d226777'
        let key = generateCancelFun(config)
        if (allowCancelList.indexOf(key) > -1) {
            cancel[key] = c;
        }
    }); // 每个请求都有一个cancel函数
    // config.cancelToken = source.token
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

export const ExcludeRequest400 = [
    {
        method: 'post',
        url: '/api/videoTask'
    }
] // 排除的请求
export const ExcludeRequest401 = ['/api/me', '/account/api/messenger/unreadCount', '/api/order/isExist?pass401'] // 排除的请求

// 添加响应拦截器
AJAX.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response.data;
}, function (error) {
    console.log(error)
    // 对响应错误做点什么，比如400、401、402等等
    if (error && error.response) {
        // console.log(error.response);
        // console.log('我是请求的中的')
        let { status, data, config } = error.response
        let message = data.message || '服务异常，请稍后再试！'
        switch (status) {
            case 400:
                let obj = ExcludeRequest400.find(item => {
                    return item.method === config.method && item.url === config.url
                })
                if (!obj) {
                    Message({
                        message: message,
                        type: 'warn',
                    });
                }
                break
            case 401:
                // if (ExcludeRequest401.indexOf(config.url) == -1) {
                //     gotoLogin()
                // }
                break
            case 403:
                if (config.headers.network403 !== 'custom403') {
                    Vue.prototype.$TsaToastV2.show({
                        message,
                        type: 'error'
                    })
                }
                break
            default:
                Message({
                    message: message,
                    type: 'error',
                });
        }
    } else {
        if (error.message.indexOf('timeout') > -1) {
            Message({
                message: '网络超时，请稍后再试',
                type: 'error',
            });
        }
    }
    return Promise.reject(error.response);
});
export const clearHttp = (key) => {
    if (cancel[key]) {
        cancel[key] && cancel[key]('Operation canceled by the user');
        cancel[key] = undefined
    }
}
// 定义对外Get、Post、File请求
export default {
    blob(url) {
        return AJAX.get(url, {
            responseType: "blob",
        })
    },
    get(url, params = {}) {
        return AJAX.get(url, {
            params
        })
    },
    post(url, param = null, headers = {}, cancelToken) {
        return AJAX.post(url, param, {
            headers,
            cancelToken
        })
    },
    put(url, param = null, headers = {}) {
        return AJAX.put(url, param, {
            headers,
        })
    },
    file(url, param = null, headers = {}) {
        return AJAX.post(url, param, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, headers)
        })
    },
    delete(url, data = null, headers = {}) {
        return AJAX.delete(url, {
            data: JSON.stringify(data),
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, headers)
        })
    },
}
